import {useState, useEffect, useMemo} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import useToggle from "../../shared/functions/useToggle";

import {uniqBy} from 'lodash'

import {
    Dialog,
    DialogContent,
    LinearProgress,
    DialogTitle,
    IconButton,
    Paper,
    Stack,
    Typography,
    Avatar
} from '@mui/material'
import {Close} from '@mui/icons-material'

import {ItemDetails} from "../items/ItemDetails";
import {fetchItemParent} from "../../redux/slices/inventory/inventory.thunks";

export default function OrderingDetails({data, open, item, onClose}) {

    const {loading, list} = useInvetoryDetail(item)

    // console.log(item)
    // console.log(data)

    return (
        <Dialog open={open} onClose={onClose} maxWidth={'lg'} fullWidth>

            <DialogTitle>
                <Stack direction={'row'} justifyContent={'end'}>

                    <IconButton onClick={onClose}>
                        <Close/>
                    </IconButton>

                </Stack>
            </DialogTitle>

            <DialogContent>
                {loading && <LinearProgress/>}

                {
                    list?.map(one => (
                        <Element
                            key={one?.id}
                            item={one}
                            isChild={one?.HasChilds === false && list?.length > 1}
                            isSelected={item?.id === one?.id}
                            hasToBuy={item?.hasToBuy === true}
                        />
                    ))
                }


            </DialogContent>
        </Dialog>
    )
}


const Element = ({item, isChild = false, isSelected = false}) => {
    const {open, handleOpen, handleClose} = useToggle()

    console.log(item)


    return (
        <>
            <Paper onClick={handleOpen} sx={{my: 2, ml: isChild ? 3 : 0, bgcolor: isSelected ? '#98d5e7' : 'white'}}>
                <Stack direction={'row'}  p={1}>

                    <Stack direction={'row'} spacing={1}>

                        {
                            item?.ImageUrl
                                ? <Avatar alt={'...'} src={item?.ImageUrl}/>
                                : <Avatar>no</Avatar>
                        }

                        <Typography mt={1}>
                            {item?.Name}
                        </Typography>

                    </Stack>

                    <Stack direction={'row'} spacing={6} pt={1}>
                        <Typography>
                            Qp: {item?.QuantityToBuy || 0}
                        </Typography>

                    </Stack>


                </Stack>
            </Paper>

            <ItemDetails item={item} open={open} onClose={handleClose}/>
        </>
    )
}

const useInvetoryDetail = (item) => {
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const {byId = {}} = useSelector(state => state.inventory)

    const list = useMemo(() => {
        const sub = [];

        sub.push(item);

        if (item?.ParentId && byId[item?.ParentId]) {
            const parent = byId[item?.ParentId];

            sub.push(parent);

            (parent?.IsParent || [])?.forEach(one => {
                if (byId[one?.ItemId]) {
                    sub.push(byId[one?.ItemId]);
                }
            })

        }


        return uniqBy([
            ...sub?.filter(one => one?.HasChilds),
            ...sub?.filter(one => !one?.HasChilds),
            ...sub?.filter(one => one?.hasToBuy === true),
        ], 'id')
    }, [byId, item])

    useEffect(() => {

        dispatch(fetchItemParent(item, (pending) => {
            setLoading(pending)

        }))
    }, [dispatch, item])

    return {loading, list}
}